'use client';

import cn from 'classnames';
import { useConversation, type WidgetProps } from '@chewy/chat-library-common';
import { Markdown, UserActionButtonPanel } from '@chewy/chat-library-components';
import type { UserActionButtonProps } from '@chewy/chat-library-components';
import styles from './WelcomeMessage.module.scss';

export interface WelcomeMessageContent {
  title?: string;
  message?: string;
  question?: string;
  showActionButtons?: boolean;
  actionButtons?: UserActionButtonProps[];
}

export default function WelcomeMessage({
  data,
  className,
}: WidgetProps<WelcomeMessageContent>) {
  const { conversationStarted } = useConversation();
  const widget = data?.[0];

  if (!widget) {
    return null;
  }

  const { title, message, question, showActionButtons, actionButtons } = widget;
  const shouldShowButtons = (conversationStarted || showActionButtons) && actionButtons && actionButtons.length;
  const shouldShowMessage = !conversationStarted && !showActionButtons && message;

  return (
    <div className={cn(styles.container, className)}>
      <div data-testid="welcome-message">
        <h1 className={styles.header}>
          <Markdown allowedElements={['strong', 'b']}>{title}</Markdown>
        </h1>
        {shouldShowMessage ? (
          <p className={styles.body}>
            <Markdown allowedElements={['strong', 'b']}>{message}</Markdown>
          </p>
        ) : null}
        {question ? (
          <p className={styles.body}>
            <Markdown allowedElements={['strong', 'b']}>{question}</Markdown>
          </p>
        ) : null}
      </div>
      {shouldShowButtons ? (
        <UserActionButtonPanel data={[{ buttons: actionButtons }]} />
      ) : null}
    </div>
  );
}
